<a [routerLink]="'/angebote/' + eventPreview.id" class="event-preview" *ngIf="eventPreview">
  <div class="event-preview__image-wrapper">
    <brt-image [image]="eventPreview.image"></brt-image>
  </div>
  <div class="event-preview__body">
    <div class="event-preview__header">
      <div class="event-preview__title">
        {{ eventPreview.name }}
      </div>
      <div class="event-preview__actions-wrapper">

      </div>

    </div>
    <div class="event-preview__tags-wrapper">

      <div *ngIf="eventLabelClass.length" class="event-preview__tag event-preview__tag--{{eventLabelClass}}">{{eventLabel}}</div>

      <div class="event-preview__tag" *ngFor="let eventTag of eventPreview.eventTags">
        {{ eventTag }}
      </div>

      <ng-container *ngIf="eventPreview.appointments.length > 0">
        <div class="event-preview__tag" *ngIf="eventPreview.appointments.length === 1">
          <span class="icon-calendar" aria-label="Icon Kalender"></span> {{ eventPreview.appointments[0].startDate }}<ng-container *ngIf="eventPreview.appointments[0].endDate.length && eventPreview.appointments[0].endDate !== eventPreview.appointments[0].startDate"> – {{ eventPreview.appointments[0].endDate }}</ng-container>
        </div>

        <ng-container *ngIf="eventPreview.appointments.length > 1">
          <div class="event-preview__tag" *ngFor="let eventDate of eventPreview.appointments.slice(0, 5)">
            <span class="icon-calendar" aria-label="Icon Kalender"></span> {{ eventDate.startDate }}<ng-container *ngIf="eventDate.endDate.length && eventDate.endDate !== eventDate.startDate"> – {{ eventDate.endDate }}</ng-container>
          </div>

          <div class="event-preview__tag" *ngIf="eventPreview.appointments.length > 5" brtTooltip [text]="getAppointmentDatesText(eventPreview.appointments)">
            <span class="icon-calendar" aria-label="Icon Kalender"></span> +{{ eventPreview.appointments.length - 5 }}
          </div>
        </ng-container>
      </ng-container>

      <div class="event-preview__tag" *ngIf="eventPreview.duration.length">
        <span class="icon-time" aria-label="Icon Zeit"></span> {{ eventPreview.duration }}
      </div>
      <div class="event-preview__tag" *ngIf="eventPreview.maxParticipants">
        <span class="icon-people" aria-label="Icon Menschen"></span> {{ eventPreview.maxParticipants }}
      </div>
      <div class="event-preview__tag" *ngIf="eventPreview.address.district.length">
        <span class="icon-location-flag" aria-label="Icon Flag"></span> {{ eventPreview.address.district }}
      </div>
    </div>
  </div>
</a>
